import React, { Component } from 'react';
import { Route, Redirect, withRouter } from 'react-router-dom';

import $ from 'jquery';
import { css } from 'glamor';
import { ToastContainer } from 'react-toastify';
import toast from '../toast';

//  ----------------   Custom components
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import RelayAnimation from '../RelayAnimation/RelayAnimation';
import UserLoginForm from '../UserLoginForm/UserLoginForm';
import OTPForm from '../OTPForm/OTPForm';
import UserSignUpForm from '../UserSignUpForm/UserSignUpForm';
import PassResetReqForm from '../PassResetReqForm/PassResetReqForm';
import PassResetForm from '../PassResetForm/PassResetForm';
import { translate } from 'react-i18next';
import './HomePage.css';
import InstagramLogin from '../InstagramLogin/InstagramLogin';

class HomePage extends Component {

  constructor(props) {
    super(props);
    this.state = {
      loading: false
    };

    this.notifySuccess = this.notifySuccess.bind(this);
    this.notifyError = this.notifyError.bind(this);
  }

  notifySuccess(msg) {
    toast.success(msg);
  }

  notifyError(msg) {
    toast.error(msg);
  }



  isAuthenticated() {
    const token = localStorage.getItem('authToken');
    if (token) {
      return true;
    }
  }

  componentDidMount() {
    const currentLocationPath = this.props.location.pathname;
    const urlForEmailVerification = currentLocationPath.includes('/verify/email');
    if (urlForEmailVerification) {
      const { token } = this.props.match.params; // token value from url params passed by <Route/>
      if (token) {
        const url = `/api/v1/email/verify/${token}`;
        const data = token;
        // api call to make the user's account verified in db based on token in url
        $.ajax({
          url: url,
          type: 'PUT',
          success: function (res) {
            if (res.status === 200) {
              localStorage.setItem('isEmailVerified', true);
              this.notifySuccess(res.message);
              this.props.history.push('/login');
            }
          }.bind(this),
          error: function (xhr, status, err) {
            console.error(url, status, err.toString());
          }.bind(this)
        });
      }
    }
  }

  matchPaths(currentPath) {
    if (currentPath.includes('/reset/password/')) return true;
    switch (currentPath) {
      case '/login':
      case '/signup':
      case '/otp':
      case '/forgot-password':
        return true;
      case '/':
        if(window.screen.width <= 1200) this.props.history.push('/login');
        return true;
      default:
        return false;
    }
  }

  render() {
    const currentLocationPath = this.props.location.pathname;
    const resetPasswordPathname = currentLocationPath.includes('/reset/password');
    const matchPaths = this.matchPaths(currentLocationPath);
    const { match } = this.props;
    const { loading } = this.state;
    const isAuthenticated = this.isAuthenticated();

    // this.props.history.push('/login');

    if (!isAuthenticated && matchPaths) {
      return (
        <div className="App d-flex flex-column">
          {/* Navbar with brand logo and language change dropdown and signup/login button */}
          <Header matchPaths={(matchPaths || resetPasswordPathname)} />

          {/* Main Section with RelayStream Animation graphic and forms */}
          <div className="container py-4 py-md-0 pt-lg-4 d-flex flex-grow" >

            {/* Animation------ */}
            <div className={`LoginScreen d-flex align-items-center align-items-lg-start ${(matchPaths || resetPasswordPathname) ? 'justify-content-around' : 'justify-content-center'}`}>

              {/* <div className="LoginScreen d-flex align-items-center justify-content-center"> */}
              {/* RelayStream Animation graphic */}

              {/* Animation------ */}
              <RelayAnimation />

              {/* forms to switch between based on path change by <Router/> */}
              <Route path="/login" component={(props) => <UserLoginForm {...props} notifySuccess={this.notifySuccess} notifyError={this.notifyError} />} />
              <Route path="/otp" component={(props) => <OTPForm {...props} notifySuccess={this.notifySuccess} notifyError={this.notifyError} />} />
              <Route path="/signup" component={(props) => <UserSignUpForm {...props} notifySuccess={this.notifySuccess} notifyError={this.notifyError} />} />
              <Route path="/forgot-password" component={(props) => <PassResetReqForm {...props} notifySuccess={this.notifySuccess} notifyError={this.notifyError} />} />
              <Route path="/reset/password/:token" component={(props) => <PassResetForm {...props} notifySuccess={this.notifySuccess} notifyError={this.notifyError} />} />

            </div>
          </div >

          {/* Footer with copyright message */}
          <Footer />
          {/* React toastify for toast notification */}
          <ToastContainer className={{ textAlign: 'center' }} progressClassName={css({ background: '#007aff' })} />
        </div >
      );
    }
    if (isAuthenticated && window.location.pathname == "/instagram/login") {
      return (
        <div className="App d-flex flex-column">
          <Route path="/instagram/login" component={(props) =>
            <InstagramLogin {...props}
              notifySuccess={this.notifySuccess}
              notifyError={this.notifyError}
            />} />
        </div>
      )
    }
    else {
      return <Redirect to={'/dashboard/main'} />;
    }
  }
}

export default withRouter(translate('translations')(HomePage));



// WEBPACK FOOTER //
// ./src/components/HomePage/HomePage.js